import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "text-center text-grey-5 q-pa-md"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_post = _resolveComponent("post")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, {
    bordered: "",
    flat: ""
  }, {
    default: _withCtx(() => [
      (_ctx.tag.post)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_post, {
              post: _ctx.tag.post
            }, null, 8, ["post"]),
            (_ctx.tag.post.link)
              ? (_openBlock(), _createBlock(_component_q_card_actions, {
                  key: 0,
                  align: "right",
                  class: "q-pt-none"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_btn, {
                      size: "sm",
                      icon: "fa fa-external-link-alt",
                      label: "View post",
                      color: "primary",
                      flat: "",
                      dense: "",
                      "no-caps": "",
                      href: _ctx.tag.post.link,
                      target: "_blank"
                    }, null, 8, ["href"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, " Post unavailable "))
    ]),
    _: 1
  }))
}